import { render, staticRenderFns } from "./AgentServiceHandoffBar.vue?vue&type=template&id=8845ea36&scoped=true"
import script from "./AgentServiceHandoffBar.vue?vue&type=script&lang=js"
export * from "./AgentServiceHandoffBar.vue?vue&type=script&lang=js"
import style0 from "./AgentServiceHandoffBar.vue?vue&type=style&index=0&id=8845ea36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8845ea36",
  null
  
)

export default component.exports